var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',[(_vm.loadedSchema)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('w-warnings',{attrs:{"model":_vm.$schema,"display-errors":true}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }